import RedisDBService from '../redis';
import socketTypes from '../../enums/socketTypes';

const REDIS_MODE = socketTypes.SOCKET;

class DBManager {
  static mode = REDIS_MODE;

  static listenerMap = {};

  static addListener = (event, callback) => {
    if (!DBManager.listenerMap[event]) {
      DBManager.listenerMap[event] = [];
    }

    const index = DBManager.listenerMap[event].push(callback) - 1;
    return () => {
      console.info(`removing event ${event}`);
      DBManager.listenerMap[event].splice(index, 1);
    };
  };

  static setMode = (mode: REDIS_MODE) => {
    DBManager.mode = mode;
  };

  static createWebSocket = (options, callback, disconnectCallback) => {
    const { redisSocketHostname } = options;
    RedisDBService.createWebSocket(redisSocketHostname, callback, disconnectCallback);
  };

  static initialize = (data, callback) => {
    const customCallback = (error, response) => {
      if (!error) {
        const listeners = this.listenerMap.initialize;
        if (listeners) {
          listeners.forEach(listener => {
            listener && listener();
          });
        }
      }
      callback(error, response);
    };
        const { syncUrl, syncApiKey, storeId } = data;
        const headers = {
          'api-key': syncApiKey,
        };
        RedisDBService.initialize(syncUrl, storeId, headers, customCallback);
  };

  // Checks handlers
  static getStoreChecks = (storeId, callback) => {
    RedisDBService.getStoreChecks(storeId, callback);
  };

  static getStoreBookings = (storeId, callback) => {
    RedisDBService.getStoreBookings(storeId, callback);
  };

  static getEmployeeChecks = (storeId, employeeId, callback) => {
    RedisDBService.getEmployeeChecks(storeId, employeeId, callback);
  };

  static subscribeToStoreChecks = (storeId, callback, subscriber) => {
    return RedisDBService.subscribeToStoreChecks(storeId, callback, subscriber);
  };

  static subscribeToStoreBookings = (storeId, callback, subscriber) => {
    return RedisDBService.subscribeToStoreBookings(storeId, callback, subscriber);
  };

  static subscribeToEmployeeChecks = (storeId, employeeId, callback, subscriber) => {
    return RedisDBService.subscribeToEmployeeChecks(storeId, employeeId, callback, subscriber);
  };

  // Notification handlers
  static getStoreNotifications = (storeId, callback) => {
    RedisDBService.getStoreNotifications(storeId, callback);
  };

  static getEmployeeNotifications = (storeId, employeeId, callback) => {
    RedisDBService.getEmployeeNotifications(storeId, employeeId, callback);
  };

  static subscribeToStoreNotifications = (storeId, callback, subscriber) => {
    return RedisDBService.subscribeToStoreNotifications(storeId, callback, subscriber);
  };

  static subscribeToEmployeeNotifications = (storeId, employeeId, callback, subscriber) => {
    return RedisDBService.subscribeToEmployeeNotifications(
          storeId,
          employeeId,
          callback,
          subscriber,
        );
  };

  // Menu handlers
  static subscribeToStoreMenu = (storeId, callback, subscriber) => {
        RedisDBService.getStoreMenu(storeId, (error, response) => {
          if (response) {
            subscriber({ type: 'add', value: { storeMenu: response } });
          }
        });
        return RedisDBService.subscribeToMenuUpdate(storeId, callback, res =>
          subscriber({ type: res.type, value: { storeMenu: res.value } }),
        );
  };

  // System channel
  static subscribeToStore = (storeId, callback, subscriber) => {
    return RedisDBService.subscribeToStore(storeId, callback, subscriber);
  };

  static getStoreMenu = (storeId, callback) => {
        RedisDBService.getStoreMenu(storeId, (error, response) => {
          console.info('getStoreMenu response', error, response);
          if (error) {
            callback(error);
          } else {
            callback(null, [response].map(menu => ({ storeMenu: menu })));
          }
        });
  };

  static parseRethinkValueToValue = res => {
    let value = res.value;
    if (res.new_val) {
      value = res.new_val;
    } else if (res.old_val) {
      value = res.old_val;
    }
    return {
      type: res.type,
      value,
    };
  };

  static ping = callback => {
    RedisDBService.ping(callback);
  };

  static close = () => {
    RedisDBService.close();
  }
}

export default DBManager;
